export default __webpack_public_path__ + "static/media/BeltLengthImg.a4f60e12.png";